import React, { Component } from "react";
import ScrollableAnchor, { configureAnchors, goToAnchor } from 'react-scrollable-anchor'

import FlowPlayer from "../Services/FlowPlayer/FlowPlayer"
import videoJSON from "../../api/Videos.json"
import dataJSON from "../../api/VideoComp.json"

import "./VideoComp.scss"

class VideoComp extends Component {
  constructor() {
    super();
    this.state = {}
  }
  render() {
    return (
      <ScrollableAnchor id="video">
        <section className="section section-video">
          <div className="padding">
            <div className="container">
              <div className="headline">
                <div className="head" dangerouslySetInnerHTML={{ __html: dataJSON.headline }}></div>
                <div className="desc" dangerouslySetInnerHTML={{ __html: dataJSON.desc }}></div>
              </div>
              <FlowPlayer videoName="הסרטון של ניקול" autoplay={false} {...videoJSON[1]} />
            </div>
          </div>
        </section>
      </ScrollableAnchor>
    );
  }
}

export default VideoComp;



// WEBPACK FOOTER //
// ./src/Components/VideoComp/VideoComp.js